import {PaymantPawapayState, PaymantPawapayAction, PaymantPawapayActionTypes} from "../../types/Payments/paymentPawapayTypes";

const initialState: PaymantPawapayState = {
    paymentPawapayData: {},
    loading: false,
    paymentPawapayErrorDara: null,
};

export const paymentPawapayReducer = (state = initialState, action: PaymantPawapayAction): PaymantPawapayState => {
    switch (action.type) {
        case PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA:
            return { ...state, loading: true, paymentPawapayErrorDara: null, paymentPawapayData: {} };
        case PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA_SUCCESS:
            return { ...state, loading: false, paymentPawapayErrorDara: null, paymentPawapayData: action.payload };
        case PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA_ERROR:
            return { ...state, loading: false, paymentPawapayErrorDara: action.payload, paymentPawapayData: {} };
        default:
            return state;
    }
};
